import styles from "@/elements-react/product-element-refactor/product-element.module.scss";
import FixImage from "@/elements-react/fix-image";
import { LayoutStyleTypes } from "@/util-react/layout";
import { ImageResizer } from "@/util/image-resizer";
import { t } from "i18next";

export interface ProductElementImagePropsFactoryProps {
  images: Array<{ path: string }> | string;
  name: string;
}

interface ProductElementImageProps {
  imageSrc?: string;
  name: string;
}

export const productElementImagePropsFactory = (props: ProductElementImagePropsFactoryProps): ProductElementImageProps => {
  const { images, name } = props;
  const pathImage = typeof images === "string" ? images : images?.[0]?.path;
  const imageSrc = pathImage ? ImageResizer.getProductImageUrl(pathImage, "160x160") : undefined;

  return { imageSrc, name };
};

export const ProductElementImage = (props: ProductElementImageProps) => {
  const { imageSrc, name } = props;

  return (
    <div className={styles.image}>
      <FixImage className={styles["image-item"]} type={LayoutStyleTypes.TYPE_SM} src={imageSrc} alt={`${t("asb79fiaugrbsfa8.product", "Product")} ${name}`} />
    </div>
  );
};
